<template>
  <div class="con-right">
    <div class="con-right-title">热点资讯</div>
    <div class="con-right-tuijian">
      <el-carousel :interval="5000" arrow="always" indicator-position="none">
        <el-carousel-item v-for="(item, key) in zxxwlist" :key="key">
          <div class="con-right-tuijian-list">
            <el-image
              fit="cover"
              style="width: 100%; height: 200px"
              :src="`${proxy.$imgurl}${item.ThumbImage==null?'':item.ThumbImage[0]}`"
            />
            <div class="con-right-tuijian-list-title">{{ item.NewsTitle }}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="con-right-tjyd">
      <div class="con-right-tjyd-con">
        <div
          class="con-right-tjyd-con-list"
          v-for="(item, key) in zxxwlist"
          :key="key"
          @click="viewxinwen(item.Id)"
        >
          <svg
            t="1687765619661"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="10740"
            width="12"
            height="12"
          >
            <path
              d="M755.2 544L390.4 874.666667c-17.066667 14.933333-44.8 14.933333-59.733333-2.133334-6.4-8.533333-10.666667-19.2-10.666667-29.866666v-661.333334c0-23.466667 19.2-42.666667 42.666667-42.666666 10.666667 0 21.333333 4.266667 27.733333 10.666666l362.666667 330.666667c17.066667 14.933333 19.2 42.666667 2.133333 59.733333 2.133333 2.133333 0 2.133333 0 4.266667z"
              fill="#333333"
              p-id="10741"
            ></path>
          </svg>
          <div class="con-right-tjyd-con-list-nr">
            {{ item.NewsTitle }}
          </div>
        </div>
      </div>
    </div>
    <div class="con-right-guanggao">
      <el-image
        style="width: 270px; height: 90px"
        :src="require('@/assets/img/common/listguanggao.png')"
      ></el-image>
    </div>
  </div>
</template>

<script setup>
import { get } from "@/utils/index";
import { reactive, getCurrentInstance } from "vue";
const { proxy } = getCurrentInstance();
// router
import { useRouter } from "vue-router";
const router = useRouter();
// vuex
// import { useStore } from "vuex";
// const store = useStore();

//热点新闻列表
let zxxwlist = reactive([]);

// 获取热点新闻和最新新闻
const rdzx = () => {
  get("/api/NewsPaper/GetNewsList", {
    PageSize: 5,
    PageIndex: 1,
    Sort: "NewsDate",
  }).then((res) => {
    // console.log(res.Data);
    zxxwlist.push(...res.Data);
    zxxwlist.map((e) => {
      if (e.ThumbImage) {
        e.ThumbImage = e.ThumbImage.split(";");
      }
    });
  });
};
rdzx();
// 查看
const viewxinwen = (id) => {
  router.push({
    path: "/hdzq/detail",
    query: {
      id: id,
    },
  });
};
</script>

<style scoped>
.con-right {
  width: 270px;
  height: auto;
  float: right;
}
.con-right-title {
  width: 80px;
  height: 36px;
  line-height: 36px;
  color: #296fab;
  border: 1px solid #296fab;
  border-radius: 36px;
  text-align: center;
  margin: 17px 0;
  box-sizing: border-box;
}
::v-deep .el-timeline {
  padding: 0;
}
.con-right-tjyd-title {
  height: 40px;
  box-sizing: border-box;
  border-bottom: 1px solid #ccc;
  display: flex;
  margin: 20px 0 10px 0;
}
.con-right-tjyd-title > span {
  display: block;
  height: 40px;
  box-sizing: border-box;
  border-bottom: 2px solid #296fab;
  line-height: 40px;
}
.con-right-tjyd-con {
  padding-top: 30px;
}
.con-right-tjyd-con-list {
  font-size: 14px;
  display: flex;
  align-items: center;
  height: 30px;
  margin: 0 0 5px 0;
}
.con-right-tjyd-con-list-nr {
  width: calc(100% - 14px);
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
  box-sizing: border-box;
  padding-left: 5px;
  cursor: pointer;
}
.con-right-tjyd-con-list-nr:hover {
  color: #296fab;
}
.con-right-guanggao {
  width: 270px;
  height: 90px;
  margin-top: 20px;
}
.con-right-tuijian-list {
  position: relative;
  width: 100%;
  height: 200px;
}
.con-right-tuijian-list-title {
  position: absolute;
  left: 0;
  bottom: 0;
  font-size: 14px;
  color: #fff;
  width: 100%;
  height: 30px;
  line-height: 30px;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
</style>
